import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getDashboardState } from '@/features/dashboardShare/store-selectors';
import { Button, TrevorIcon } from '@trevor/ui-components';

export const ConfigureEmbedDashboardButton: FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = (props) => {
  const { isPublic } = useSelector(getDashboardState);

  if (isPublic) {
    return null;
  }

  return (
    <Button
      expanded
      variant="secondary"
      icon={<TrevorIcon name="settings" />}
      {...props}
    >
      Configure dashboard embed
    </Button>
  );
};
